import React from "react";
import { useRouter } from "next/router";
import styles from "./CompositeScores.module.scss";

const SCORES_CONFIG = [
    {
        key: "grunnstada",
        label_is: "Grunnstaða",
        label_en: "Foundation",
        desc_is: "Hversu vel er fyrirtækið undirbúið",
        desc_en: "How well prepared the company is",
        color: "#009448",
    },
    {
        key: "thrystingur",
        label_is: "Þrýstingur",
        label_en: "Pressure",
        desc_is: "Ytri kröfur og markaðsþrýstingur",
        desc_en: "External demands and market pressure",
        color: "#C54E3F",
    },
    {
        key: "taekifaeri",
        label_is: "Tækifæri",
        label_en: "Opportunity",
        desc_is: "Tækifæri til hagræðingar og sparnaðar",
        desc_en: "Opportunity for optimization and savings",
        color: "#E2B93B",
    },
];

export default function CompositeScores({ composite }) {
    const { locale } = useRouter();

    return (
        <div className={styles.scoresRow}>
            {SCORES_CONFIG.map(
                ({ key, label_is, label_en, desc_is, desc_en, color }) => {
                    const value = composite[key];
                    const pct = value != null ? (value / 5) * 100 : 0;
                    const label = locale === "en" ? label_en : label_is;
                    const desc = locale === "en" ? desc_en : desc_is;

                    return (
                        <div key={key} className={styles.scoreCard}>
                            <span className={styles.scoreLabel}>{label}</span>
                            <span
                                className={styles.scoreValue}
                                style={{ color }}
                            >
                                {value != null ? value : "—"}
                            </span>
                            <div className={styles.scoreBar}>
                                <div
                                    className={styles.scoreBarFill}
                                    style={{
                                        width: `${pct}%`,
                                        backgroundColor: color,
                                    }}
                                />
                            </div>
                            <span className={styles.scoreDesc}>{desc}</span>
                        </div>
                    );
                },
            )}
        </div>
    );
}
